import Repository from './repository';

const resource = '/roles/merchant';
export default {
	all() {
		return Repository.getWithAuth(`${resource}`);
	},
	add(payload) {
		return Repository.postWithAuth(
			`${resource}`,
			payload,
			{},
			{ noCache: true }
		);
	},
	update(merchant_id, payload) {
		return Repository.putWithAuth(`${resource}/${merchant_id}`, payload);
	},
	delete(id) {
		return Repository.deleteWithAuth(`${resource}/${id}`);
	},
};
